var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { useMeasure } from 'react-use';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { searchActions } from '../../../../search.actions';
import styles from './searchResultsPagination.module.scss';
/** Represents a component that is a wrapper for the pagination component */
export const SearchResultsPagination = (_a) => {
    var props = __rest(_a, []);
    const dispatch = useAppDispatch();
    const [ref, { width }] = useMeasure();
    const pageRangeAdjusted = useMemo(() => (width > 40 ? Math.floor(width / 40) : 6), [width]);
    const handlePageChange = (page) => {
        dispatch(searchActions.params.update({ page }));
    };
    return (_jsx("div", Object.assign({ ref: ref, className: styles.root }, { children: _jsx(Pagination, Object.assign({}, props, { pageRangeDisplayed: pageRangeAdjusted, onPageChange: handlePageChange })) })));
};
